﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconIdBadge2 } from "@tabler/icons-react";
import { PuestosTrabajoDef } from "./PuestosTrabajoDef";

export const PuestosTrabajoIcon = IconIdBadge2;
export const PuestosTrabajoHelpText = "* Aquí tendra todos los puestos de trabajo disponibles para asignar.";

export class PuestosTrabajo extends Entity<PuestosTrabajoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PuestosTrabajoDef(), parentKeys);
        super.Form = import('./PuestosTrabajoForm').then((module) => module.PuestosTrabajoForm);
        this.Title = "Puestos de trabajo";
        this.Icon = PuestosTrabajoIcon;
        this.HelpText = PuestosTrabajoHelpText;
    }
}